export enum RemoveFilterType {
  Classification = "classification",
  AccountTypes = "accountTypes",
  ReportingAccountType = "reportingAccountType",
}
